import { createMuiTheme } from '@material-ui/core/styles';

import AmplifyTheme from 'aws-amplify-react/dist/Amplify-UI/Amplify-UI-Theme';

const defaultTheme = createMuiTheme({
  palette: {
    primary: {
      light: '#3378ab',
      main: '#005796',
      dark: '#003c69',
      contrastText: '#fff'
    },
    secondary: {
      light: '#33d8ea',
      main: '#00cfe5',
      dark: '#0090a0',
      contrastText: '#000'
    },
    environment: {
      prod: '#FAB72D',
      dev: '#E2161A',
      other: '#6D7278'
    }
  },
  typography: {
    useNextVariants: true
  },
  shape: {
    borderRadius: 8
  },
  drawerOpenWidth: 240,
  pageHeaderHeight: 102
});

const appTheme = {
  ...defaultTheme,
  overrides: {
    MuiButton: {
      label: {
        textTransform: 'none'
      }
    },
    MuiIconButton: {
      root: {
        padding: defaultTheme.spacing.unit * 1
      }
    },
    MuiTooltip: {
      tooltip: {
        borderRadius: 4
      }
    },
    MuiListItemText: {
      primary: {
        fontWeight: defaultTheme.typography.fontWeightMedium
      }
    },
    MuiListItemIcon: {
      root: {
        marginRight: 0,
        '& svg': {
          fontSize: 20
        }
      }
    }
  },
  mixins: {
    ...defaultTheme.mixins,
    toolbar: {
      minHeight: 48
    }
  }
};

const toastTheme = {
  toast: Object.assign({}, appTheme.typography.subtitle1, {
    backgroundColor: appTheme.palette.error.main,
    color: appTheme.palette.error.contrastText
  })
};

const awsTheme = Object.assign({}, AmplifyTheme, appTheme, toastTheme);

export { awsTheme };
export { appTheme };
